import { PlatformInstagramBorderIcon } from 'ui-components/dist/PlatformInstagramBorderIcon';
import { PlatformTikTokColorIcon } from 'ui-components/dist/PlatformTikTokColorIcon';
import { PlatformYouTubeColorIcon } from 'ui-components/dist/PlatformYouTubeColorIcon';
import { SOCIAL_PLATFORMS } from '~/constants';

export const PLATFORM_FOLOWERS_ICON_COMPONENT = {
  [SOCIAL_PLATFORMS.instagram]: PlatformInstagramBorderIcon,
  [SOCIAL_PLATFORMS.tiktok]: PlatformTikTokColorIcon,
  [SOCIAL_PLATFORMS.youtube]: PlatformYouTubeColorIcon,
};
